export const sanitizeUrl = (url: string) => {
  try {
    const urlObj = new URL(url);

    urlObj.search = '';
    urlObj.hash = '';
    urlObj.pathname = urlObj.pathname.replace(/[^a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]/g, '');

    return urlObj.toString();
  } catch {
    throw new Error('Invalid image URL');
  }
};
